// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import {
  TransferFactoryWithChoiceContext,
  GetFactoryRequest,
} from '@digitalasset/transfer-instruction-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { Transfer } from '@daml.js/splice-api-token-transfer-instruction/lib/Splice/Api/Token/TransferInstructionV1';
import { useTransferInstructionApiClient } from '../../../contexts/TransferInstructionApiContext';

export const useTransferFactoryWithContext: () => UseMutationResult<
  TransferFactoryWithChoiceContext,
  string,
  {
    registrar: string;
    transfer: Transfer;
  }
> = () => {
  const transferInstructionApi = useTransferInstructionApiClient();

  return useMutation({
    mutationKey: ['transferFactoryWithContext', transferInstructionApi],
    mutationFn: async ({ registrar, transfer }) => {
      const request = {
        choiceArguments: {
          expectedAdmin: registrar,
          transfer,
          extraArgs: { context: { values: {} }, meta: { values: {} } },
        },
        excludeDebugFields: true,
      } as GetFactoryRequest;
      return transferInstructionApi.getTransferFactory(registrar, request);
    },
  });
};
